import {User} from "@app/core/user/domain/entities/user";

export class UserMapper {
  static deserialize(param: Record<string, any>): User {
    return new User(
      param.name,
      param.surname,
      param.email,
      param.language,
      param.is_guest,
    );
  }
}
